import axios from 'axios';

const instance = axios.create({
  // baseURL: 'https://api.bsac-japan.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
});

export default instance;
